<template>
  <div class="home">
    <section class="pb-3 border-b border-gray-300 relative flex flex-row justify-center items-center">
   <img class="w-16 h-16  ml-15 md-3 rounded-full border border-white" src="/images/1.jpeg" alt="profile">
   <h2 class="w-auto text-3xl pl-4 font-bold">Welcome! Alissa</h2>
   </section>
   <div class="container">
     <el-calendar :range="['2021-04-04', '2021-04-04']"></el-calendar>
   </div>
   <section class="pb-20">
     <el-carousel :interval="4000" type="card" height="200px">
      <el-carousel-item>
        <img src="/images/6.jpeg" alt="Image 1"/>
      </el-carousel-item>
       <el-carousel-item>
        <img src="/images/2.jpeg" alt="Image 2"/>
      </el-carousel-item>
       <el-carousel-item>
        <img src="/images/3.jpeg" alt="Image 3"/>
      </el-carousel-item>
       <el-carousel-item>
        <img src="/images/4.jpeg" alt="Image 4"/>
      </el-carousel-item>
       <el-carousel-item>
        <img src="/images/7.jpeg" alt="Image 5"/>
      </el-carousel-item>
     </el-carousel>
   </section>
   
  </div>
</template>

<script>

export default {
  data(){
    return{
    
    }
  }
}
</script>
<style scope>
.h2{
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.el-carousel__item h3 {
    color:#ff9db5;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
  
  .el-carousel__item:nth-child(2n) {
    background-color: #f09cb1;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #f09cb1;
  }
</style>>

